/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable padding-line-between-statements */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import ReactHlsPlayer from 'react-hls-player';
import clsx from 'clsx';

import { ClipAudioProps } from './ClipAudioSection.types';
import { AudioSlider, useStyles } from './ClipAudioSection.styles';
import { Loader } from 'shared/components';
import { useLocale } from 'shared/hooks';

// function ValueLabelComponent(props: any) {
//   const { children, open, value, startTime } = props;
//   const adjustedValue = (Number(value / 10) - startTime).toFixed(2); // Calculate display value as 1 to 15
//   return (
//     <Tooltip open={open} enterTouchDelay={0} placement="bottom" title={`${adjustedValue}s`}>
//       {children}
//     </Tooltip>
//   );
// }

export const ClipAudioSelection = ({
  activeStep,
  setActiveStep,
  startTime,
  setSelectedAudioRange,
  streamURL,
  clipDuration,
  setClipDuration,
  // audioSliderValue,
  sliderValue,
  setSelectedRange,
  isFromCeremony,
  updateAudio,
  setUpdateAudio,
  editAudio,
  setEditAudio,
  clipAudioTime,
}: ClipAudioProps) => {
  const styles = useStyles();
  const videoRef = useRef<HTMLVideoElement | null>(null); // Correct type
  // const [isPlaying, setIsPlaying] = useState(false);
  // const [metadataLoaded, setMetadataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { formatMessage } = useLocale();

  const subtractValue = startTime - 6;

  // const startedAt = startTime * 10;
  // const endedAt = (startTime + 15) * 10;
  // const endedAtt = startTime + 15;

  const startedAt = isFromCeremony && subtractValue > 0 ? subtractValue * 10 : startTime * 10;
  const newStartedAt = startedAt / 10;

  const endedAt = (newStartedAt + clipAudioTime) * 10;
  // const endedAtt = startTime + 15;

  const sliderValues = sliderValue.map((value: number) => value * 10);
  const [playbackTime, setPlaybackTime] = useState(startedAt); // Store the current playback time
  const [isSeeking, setIsSeeking] = useState(false);

  const videoDifference = sliderValues[1] - sliderValues[0];

  const extractVideoDifference = videoDifference;

  const videoEndValue = startedAt + extractVideoDifference;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [value, setValue] = useState<number[]>(
    sliderValues.length > 0 ? [startedAt, videoEndValue] : [startedAt, endedAt],
  );

  // function formatTime(seconds: number): string {
  //   const hours = Math.floor(seconds / 3600);
  //   const minutes = Math.floor((seconds % 3600) / 60);
  //   const remainingSeconds = Math.floor(seconds % 60); // Floor to remove decimals

  //   return `${hours.toString().padStart(2, '0')}:${minutes
  //     .toString()
  //     .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  // }

  const handleSnackBarClose = () => {
    setActiveStep(activeStep + 1);
    setUpdateAudio(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (videoRef.current && startedAt) {
      if (videoRef.current.currentTime >= endedAt) {
        videoRef.current.currentTime = startedAt / 10;

        videoRef.current.play();
      }
    }
    // eslint-disable-next-line no-unused-expressions
    editAudio.length === 0 && setEditAudio(sliderValues.length > 0 ? [startedAt, videoEndValue] : [startedAt, endedAt]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startedAt]);

  // useEffect(() => {
  //   if (editAudio.length === 0 && value.length > 0) {
  //     setEditAudio(value);
  //   }
  // }, [value, editAudio]);

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    setClipDuration(null);
    setSelectedRange([]);
    setUpdateAudio(false);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
    // eslint-disable-next-line prefer-const
    let [start, end] = newValue as number[];
    const [prevStart, prevEnd] = updateAudio ? (editAudio as number[]) : (value as number[]);

    const audioDifference = end - start;

    if (clipDuration) {
      if (audioDifference < 20) {
        return;
      }
    }

    if (prevStart === start) {
      if (videoDifference < audioDifference) {
        setIsSeeking(true);
        const needToAdd = videoDifference - audioDifference;

        setValue([start - needToAdd, end]);
        setEditAudio([start - needToAdd, end]);
      } else {
        setValue([start, end]);
        setEditAudio([start, end]);
      }
    }
    if (prevEnd === end) {
      if (videoDifference < audioDifference) {
        setIsSeeking(true);
        const needToAdd = videoDifference - audioDifference;
        setValue([start, end + needToAdd]);
        setEditAudio([start, end + needToAdd]);
      } else {
        setValue([start, end]);
        setEditAudio([start, end]);
      }
    }

    if (audioDifference < videoDifference) {
      setIsSeeking(false);
    }

    // setEditAudio([start, end]);
    setSelectedAudioRange([start / 10, end / 10]);

    // Seek to the start time if `videoRef` exists
    if (videoRef.current) {
      videoRef.current.currentTime = start / 10;
    }
  };

  // Handle loaded metadata to start playback from the selected start time
  // eslint-disable-next-line consistent-return
  const handleLoadedMetadata = () => {
    // setMetadataLoaded(true);
    // const [selectedStart] = value;

    if (videoRef.current) {
      const updatedStartTime = isFromCeremony ? subtractValue : startTime;
      videoRef.current.currentTime = updateAudio ? Math.round(editAudio[0] / 10) : updatedStartTime;
      // videoRef.current.currentTime = sliderValue[0] || selectedStart || startedAt / 10; // Start playback from start time
    }
  };

  // Monitor time updates and pause the player at the end time
  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const [selectedStart, selectedEnd] = updateAudio ? editAudio : value;

      // Loop within selected range
      if (videoRef.current.currentTime >= Number(selectedEnd / 10)) {
        videoRef.current.currentTime = Number(selectedStart / 10); // Restart from the beginning of the selected range

        videoRef.current.play(); // Continue playing for seamless looping
      }
      setPlaybackTime(videoRef.current.currentTime * 10);
    }
  };

  const handleWaiting = () => {
    setIsLoading(true); // Show loader when buffering
  };

  const handlePlaying = () => {
    setIsLoading(false); // Hide loader when video starts playing
  };

  const [selectedStart, selectedEnd] = updateAudio ? editAudio : value;

  const difference = selectedEnd - selectedStart;

  const isAudioMissMatched = clipDuration !== null && difference > clipDuration;

  // if (clipDuration) {
  //   setSnackbarMessage(`Ensure your audio timing is aligned within ${clipDuration / 10} seconds.`);
  // }

  // if (!isAudioMissMatched) {
  //   setSnackbarMessage(null);
  // }

  const markerPosition = ((playbackTime - startedAt) / (endedAt - startedAt)) * 100; // Percentage position

  return (
    <div>
      <div className={styles.container}>
        {isLoading && (
          <div className={styles.hlsPlayerLoader}>
            <Loader fullScreen />
          </div>
        )}
        <div className={styles.logoContainer}>
          <div className={styles.containerPlayer}>
            <div>
              <ReactHlsPlayer
                playerRef={videoRef}
                src={streamURL}
                // width="800px"
                height="100%"
                controlsList="nodownload"
                preload="metadata"
                disablePictureInPicture
                // controls
                playsInline
                // onChange={pauseVideo}
                onLoadedMetadata={handleLoadedMetadata}
                onTimeUpdate={handleTimeUpdate}
                autoPlay
                loop
                className={styles.hlsPlayer}
                onWaiting={handleWaiting}
                onPlaying={handlePlaying}
              />
            </div>
            <div className={styles.overlay}>
              <Typography className={styles.overlayText}>
                {formatMessage({
                  id: 'studentSelection.clip.audio.overlay.text',
                })}
              </Typography>
            </div>
          </div>

          <div className={styles.subTitle}>
            <Typography>
              {formatMessage({
                id: 'studentSelection.clip.edit.audio.subtitle',
              })}
            </Typography>
          </div>
          <div>
            <Typography className={styles.errorText}>
              {isSeeking
                ? formatMessage({
                    id: 'studentSelection.clip.audio.warning.text',
                  })
                : '\u00A0'}
              {/* {formatMessage({ id: 'studentSelection.clip.audio.warning.text' }, { audioDifference: difference / 10 })} */}
            </Typography>
          </div>

          {value && value.length === 2 && (
            <div className={styles.sliderContainer}>
              {/* @ts-expect-error - Material-UI v4 styled component type conflict with React 18 */}
              <AudioSlider
                onChange={handleChange}
                value={updateAudio ? editAudio : value}
                min={startedAt}
                max={endedAt}
                // valueLabelDisplay="auto"
                // ValueLabelComponent={props => <ValueLabelComponent {...props} startTime={startTime} />}
                className={clsx({
                  audioMismatch: isAudioMissMatched, // Apply class for red color
                  audioMatch: !isAudioMissMatched, // Apply class for green color
                })}
              />
              {markerPosition > 0 && (
                <div
                  style={{
                    left: `${markerPosition}%`,
                  }}
                  className={styles.playerIndicator}
                />
              )}
              {/* <div style={{ display: 'flex' }}>
                <div className={styles.inTimeText}>
                  <Typography style={{ fontWeight: 'bold' }}>
                    {audioSliderValue.length === 2
                      ? formatTime(audioSliderValue[0]) // Use `audioSliderValue[1]` if it has two elements
                      : formatTime(
                          sliderValue.length === 2
                            ? sliderValue[0] // Use `sliderValue[1]` if `sliderValue` has two elements
                            : startTime, // Fallback to `endedAtt` if neither condition is met
                        )}
                  </Typography>
                  <Typography>In time</Typography>
                </div>
                <div className={styles.outTimeText}>
                  <Typography style={{ fontWeight: 'bold' }}>
                    {audioSliderValue.length === 2
                      ? formatTime(audioSliderValue[1]) // Use `audioSliderValue[1]` if it has two elements
                      : formatTime(
                          sliderValue.length === 2
                            ? sliderValue[1] // Use `sliderValue[1]` if `sliderValue` has two elements
                            : endedAtt, // Fallback to `endedAtt` if neither condition is met
                        )}
                  </Typography>
                  <Typography>Out time</Typography>
                </div>
              </div> */}
            </div>
          )}
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.backButton}
            onClick={() => {
              handleBack();
            }}
          >
            Back
          </Button>
          <Button
            className={clsx(isAudioMissMatched ? styles.confirmDisabledButton : styles.confirmButton)}
            onClick={() => {
              handleSnackBarClose();
            }}
            disabled={isAudioMissMatched}
          >
            Next
          </Button>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};
